
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Spinner } from "@/components/ui/spinner";

interface LoadingPageProps {
  message?: string;
}

const LoadingPage = ({ message = "Loading..." }: LoadingPageProps) => {
  return (
    <>
      <Helmet>
        <title>Loading | CRM</title>
      </Helmet>
      
      <div className="flex h-[calc(100vh-100px)] items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <Spinner size="lg" />
          <p className="text-lg">{message}</p>
        </div>
      </div>
    </>
  );
};

export default LoadingPage;
